import React, {createContext, FC, useState} from "react";

import { DARK_THEME, LIGHT_THEME } from '../constants/themeConstants';
import {ThemeContextType} from "../types/theme";

export const ThemeContext = createContext<ThemeContextType | null>(null);

export const ThemeProvider: FC<{children: React.ReactNode}> = ({children}) => {
    const [themeMode, setThemeMode] = useState(LIGHT_THEME);

    window.localStorage.setItem("themeMode", themeMode);

    const toggleTheme = () => {
        setThemeMode((prevTheme) => prevTheme === LIGHT_THEME ? DARK_THEME : LIGHT_THEME);
        window.localStorage.setItem("themeMode", themeMode);
    }

    return (
        <ThemeContext.Provider value={{
            theme: themeMode, toggleTheme
        }}>{children}</ThemeContext.Provider>
    )
}
